import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal, NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { PagingModel } from 'src/app/models/paging/paging.model';
import { RelatedProductListItem, RelatedProductResponseModel } from 'src/app/models/product/relatdProduct';
import { LocalstorageService } from 'src/app/services/Common/localstorage.service';
import { HomePageService } from 'src/app/services/home-page.service';
import { ProductNameComponent } from '../product-name/product-name.component';

@Component({
  selector: 'app-related-product-list',
  templateUrl: './related-product-list.component.html',
  styleUrls: ['./related-product-list.component.css']
})
export class RelatedProductListComponent implements OnInit {
  Loader: boolean = false;
  relatedListModel: RelatedProductListItem = new RelatedProductListItem();
  relatedProductResponseModel: RelatedProductResponseModel = new RelatedProductResponseModel();
  productId: string;
  localStorage: LocalstorageService;
  totalPages: number;
  pageNumber: number = 1;
  pagingModel: PagingModel = new PagingModel();

  constructor(private homePageService: HomePageService, private activatedRoute: ActivatedRoute, private router: Router, private _localStorage: LocalstorageService, private modalService: NgbModal) {

    this.pagingModel.pageNumber = 1;
    if (this.totalPages == undefined || this.totalPages == 0) {
      this.totalPages = 1;
    }
    this.localStorage = _localStorage;
  }

  ngOnInit() {
    this.activatedRoute.params.subscribe((param) => {
      this.productId = param.productId;
    });
    if(this.productId == undefined) {
    this.productId = localStorage.getItem('productId');
    }
    this.relatedProductList();
  }

  loadPage(pagingModel: PagingModel) {
    this.relatedListModel.PageNumber = pagingModel.pageNumber;
    this.relatedListModel.PageSize = pagingModel.pageSize;
    this.relatedProductList();
  }

  relatedProductList() {
    this.Loader = true;
    this.relatedListModel.ProductId = this.productId;
    this.homePageService.RelatedProductListing(this.relatedListModel)
      .subscribe((response) => {
        this.Loader = false;
        let responseBody = JSON.parse(response._body)
        if (responseBody.isSuccess) {
          this.relatedProductResponseModel.ProductSort = responseBody.responseData;
          this.relatedProductResponseModel.ProductSort.forEach((element, index) => {
            this.relatedProductResponseModel.ProductSort[index].imageLoader = true;
            this.homePageService.ProductImageList(element.productId)
              .subscribe((response) => {
                let responseimage = JSON.parse(response._body)
                if (responseimage.isSuccess) {
                  this.relatedProductResponseModel.ProductSort[index].productImage = responseimage.responseData;
                  this.relatedProductResponseModel.ProductSort[index].imageLoader = false;

                } (err) => {
                }
              })
          });
          this.relatedProductResponseModel.TotalPages = responseBody.totalPages;
          this.totalPages = this.relatedProductResponseModel.TotalPages == undefined ? 0 : this.relatedProductResponseModel.TotalPages;
        } (err) => {
          this.Loader = false;
        }
      })
  }

  relatedProductConfirm(item) {
    if (this.localStorage.getToken()) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/order-confirm/' + item.productId]));
      window.open('#' + url, '_blank');
    } else {
      this.router.navigate(['/login'], { queryParams: { return: window.location.origin + '/#/product-page/' + item.productId } });
    }
  }

  requestQuote(item) {
    if (this.localStorage.getToken()) {
      const url = this.router.serializeUrl(
        this.router.createUrlTree(['/request-quote/' + item.productId]));
      window.open('#' + url, '_blank');
    } else {
      this.router.navigate(['/login'], { queryParams: { return: window.location.origin + '/#/product-page/' + item.productId } });
    }
  }

  uploadImage(item) {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/product-page/' + item.productId]));
    window.open('#' + url, '_blank');
  }

  shopProductName(item) {
    var modalConfig = new NgbModalConfig();
    modalConfig.size = "sm";
    modalConfig.centered = true;
    modalConfig.backdrop = false;
    modalConfig.keyboard = false;
    let modalRef = this.modalService.open(ProductNameComponent, modalConfig);
    modalRef.componentInstance.productTitle = item.productTitle;
  }

}
